<template>
  <div class="country-selector">
  
    <button 
      @click="setCountry('ch')" 
      :class="{ active: selectedCountry === 'ch' }"
      class="country-btn country-ch"
    >
      🇨🇭 Suisse
    </button>
     <button 
      @click="setCountry('fr')" 
      :class="{ active: selectedCountry === 'fr' }"
      class="country-btn country-fr"
    >
      🇫🇷 France
    </button>
  </div>
</template>

<script>
export default {
  name: 'CountrySelector',
  computed: {
    selectedCountry () {
      return this.$store.state.selectedCountry
    }
  },
  methods: {
    setCountry (country) {
      this.$store.commit('SET_COUNTRY', country)
    }
  }
}
</script>

<style scoped lang="scss">
.country-selector {
  display: flex;
  gap: 10px;
  margin-bottom: 0px;
}

.country-btn {
  padding: 8px 16px;
  border: 1px solid #000;
  background: white;
  cursor: pointer;
  border-radius: 35px;
  transition: all 0.3s;
}

.country-btn.active {
  background: #000; 
   color: white;
  border-color: #000;

  &:before {
    display: none;
  }
}

.country-btn:hover {
  opacity: 0.8;
}
</style>